var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design---[Web]-Leagues",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leagues-(Create)-(Step-2)-[D]",
    transform: "translate(-669.000000, -636.000000)",
    fill: "#C80502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(644.000000, 348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Plus",
    transform: "translate(20.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,5 C28.2842712,5 35,11.7157288 35,20 C35,28.2842712 28.2842712,35 20,35 C11.7157288,35 5,28.2842712 5,20 C5,11.7157288 11.7157288,5 20,5 Z M20,6.66666667 C12.6362033,6.66666667 6.66666667,12.6362033 6.66666667,20 C6.66666667,27.3637967 12.6362033,33.3333333 20,33.3333333 C27.3637967,33.3333333 33.3333333,27.3637967 33.3333333,20 C33.3333333,12.6362033 27.3637967,6.66666667 20,6.66666667 Z M21.6153136,11.6666667 L21.615,18.3833333 L28.3333333,18.3846864 L28.3333333,21.6153136 L21.615,21.615 L21.6153136,28.3333333 L18.3846864,28.3333333 L18.3833333,21.615 L11.6666667,21.6153136 L11.6666667,18.3846864 L18.3833333,18.3833333 L18.3846864,11.6666667 L21.6153136,11.6666667 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPlus);
export default __webpack_public_path__ + "static/media/round-plus.743d71b9f2c2b9b85b96d700007017d8.svg";
export { ForwardRef as ReactComponent };